/* eslint-disable jsx-a11y/href-no-hash */

import i18n from "lib/i18n";
import PropTypes from "prop-types";
import React from "react";

export default function MobileToggle({ onClick }) {
  return (
    <a className="toggle" href="#" onClick={onClick}>
      <i className="icon-caret-down" />
      <i className="icon-caret-up" />
      {i18n.t("editorial_menu.mobile_heading")}
    </a>
  );
}

MobileToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
};
